import React, {Dispatch, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import {SearchForm, SearchFormValues} from './search-form';
import * as Styled from './page-search-bar.styles';
import {RequestStatusForm, RequestStatusFormValues} from '../request-status-form';
import {OfficeProcessedResponse} from '@shared/core';

interface PageSearchBarProps {
  searchValue?: string;
  handleSearchSubmit?: (data: SearchFormValues) => void;
  handleSearchName?: (event: React.FormEvent<HTMLOrSVGElement & HTMLInputElement>) => void;
  handleSearchRequestStatus?: (data: RequestStatusFormValues) => void;
  userRole?: 'manager' | 'employee';
  findJiraOffice?: boolean;
  setSelectedOffice?: Dispatch<SetStateAction<OfficeProcessedResponse>>;
  isSearchDisabled?: boolean;
  isStatusDisabled?: boolean;
  selectedRequestStatus?: string | null;
}

const PageSearchBar: React.FC<PageSearchBarProps> = ({
  searchValue,
  handleSearchSubmit,
  handleSearchName,
  handleSearchRequestStatus,
  userRole = 'manager',
  findJiraOffice,
  setSelectedOffice,
  isSearchDisabled = false,
  isStatusDisabled = false,
  selectedRequestStatus,
  children,
}) => {
  const {t} = useTranslation();

  return (
    <Styled.PageSearchBarContainer>
      {userRole !== 'employee' && (
        <Styled.SearchNameInput
          value={searchValue}
          placeholder={t('placeholders.search')}
          onChange={handleSearchName}
          icon="u_search"
          disabled={isSearchDisabled}
        />
      )}
      {handleSearchSubmit || handleSearchRequestStatus ? (
        <Styled.FormsContainer>
          {handleSearchSubmit && (
            <Styled.SearchFormContainer>
              <SearchForm onSubmit={handleSearchSubmit} findJiraOffice onSelectOffice={setSelectedOffice} />
            </Styled.SearchFormContainer>
          )}
          {handleSearchRequestStatus && userRole !== 'employee' && (
            <RequestStatusForm
              key={selectedRequestStatus || 'empty'}
              onSubmit={handleSearchRequestStatus}
              disabled={isStatusDisabled}
              defaultValue={selectedRequestStatus}
            />
          )}
        </Styled.FormsContainer>
      ) : null}
      {children}
    </Styled.PageSearchBarContainer>
  );
};

export default PageSearchBar;
